const projectDetails = (projectId: number) => `/project/${projectId}`;

const editProject = (projectId: number) => `${projectDetails(projectId)}/edit`;

const newQuote = (projectId: number) => `${projectDetails(projectId)}/quotes/new`;

const viewOrEditQuote = (projectId: number, quoteId: number) => `${projectDetails(projectId)}/quotes/${quoteId}`;

const newQuoteRevision = (projectId: number, quoteId: number) =>
  `${projectDetails(projectId)}/quotes/${quoteId}/new-revision`;

const viewOrEditQuoteBillOfMaterials = (projectId: number, quoteId: number) =>
  `${projectDetails(projectId)}/quotes/${quoteId}/bill-of-materials`;

const viewOrEditDesignBillOfMaterials = (projectId: number, designId: number) =>
  `${projectDetails(projectId)}/designs/${designId}/bill-of-materials`;

const viewQuoteHandoverPack = (projectId: number, quoteId: number) =>
  `${projectDetails(projectId)}/quotes/${quoteId}/handover-pack`;

const viewDesignHandoverPack = (projectId: number, designId: number) =>
  `${projectDetails(projectId)}/designs/${designId}/handover-pack`;

const newDesignFromQuote = (projectId: number, quoteId: number) =>
  `${projectDetails(projectId)}/quotes/${quoteId}/create-design`;

const editDesign = (projectId: number, designId: number) => `${projectDetails(projectId)}/designs/${designId}/edit`;

const newDesignRevision = (projectId: number, designId: number) =>
  `${projectDetails(projectId)}/designs/${designId}/new-revision`;

const dataForDesignDrawings = (projectId: number, designId: number) =>
  `${projectDetails(projectId)}/designs/${designId}/data-for-design-drawings`;

const manifoldDiagramPdf = (projectId: number, designId: number, unitId: number) =>
  `${projectDetails(projectId)}/designs/${designId}/units/${unitId}/pdf`;

const editPdfDetails = (projectId: number, designId: number, unitId: number) =>
  `${projectDetails(projectId)}/designs/${designId}/units/${unitId}/pdf/edit`;

export const projectUrls = {
  projectDetails,
  editProject,
  newQuote,
  editQuote: viewOrEditQuote,
  viewQuoteHandoverPack,
  viewDesignHandoverPack,
  newQuoteRevision,
  editQuoteBillOfMaterials: viewOrEditQuoteBillOfMaterials,
  newDesignFromQuote,
  editDesign,
  newDesignRevision,
  editDesignBillOfMaterials: viewOrEditDesignBillOfMaterials,
  dataForDesignDrawings,
  manifoldDiagramPdf,
  editPdfDetails,
};
